/*
    Copyright (c) Microsoft Corporation. All rights reserved.
    Licensed under the MIT license.
*/
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define(["require", "exports", "../FluxCommon/Store", "../FluxCommon/ActionsHubManager", "./PodsActions", "../Constants"], function (require, exports, Store_1, ActionsHubManager_1, PodsActions_1, Constants_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var PodsStore = /** @class */ (function (_super) {
        __extends(PodsStore, _super);
        function PodsStore() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this._setPodsList = function (payload) {
                _this._state.podsList = payload.podsList;
                _this._state.isLoading = payload.isLoading;
                _this.emit(Constants_1.PodsEvents.PodsFetchedEvent, _this);
            };
            _this._setPodsListByLabel = function (payload) {
                _this._state.podListByLabel[payload.labelSelector] = payload.podsList;
                _this._state.isLoading = payload.isLoading;
                _this.emit(Constants_1.PodsEvents.LabelledPodsFetchedEvent, _this);
            };
            return _this;
        }
        PodsStore.getKey = function () {
            return "pods-store";
        };
        PodsStore.prototype.initialize = function (instanceId) {
            _super.prototype.initialize.call(this, instanceId);
            this._state = { podsList: undefined, podListByLabel: {}, isLoading: true };
            this._actions = ActionsHubManager_1.ActionsHubManager.GetActionsHub(PodsActions_1.PodsActions);
            this._actions.podsFetched.addListener(this._setPodsList);
            this._actions.podsFetchedByLabel.addListener(this._setPodsListByLabel);
        };
        PodsStore.prototype.disposeInternal = function () {
            this._actions.podsFetched.removeListener(this._setPodsList);
            this._actions.podsFetchedByLabel.removeListener(this._setPodsListByLabel);
        };
        PodsStore.prototype.getState = function () {
            return this._state;
        };
        return PodsStore;
    }(Store_1.StoreBase));
    exports.PodsStore = PodsStore;
});
